import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";

import "bootstrap/dist/css/bootstrap.min.css";

import CartProvider from "./CartContext";
import Nav from "./components/Nav";
import Nav2 from "./components/Nav2";
import Footer from "./components/Footer";

import ProductList from "./components/ProductList";
import ProductDetail from "./components/ProductDetail";
import ProductDetailAdult from "./components/ProductDetailAdult";
import Cancel from "./components/pages/Cancel";
import Success from "./components/pages/Success";
import ProductPage from "./components/ProductPage";
import ContactUs from "./components/ContactUs";

import AboutUs from "./components/AboutUs";
import Policy from "./components/Policy";
import Refund from "./components/Refund";
import Terms from "./components/Terms";
import Adult from "./components/Adult";
import ImageTable from "./components/ImageTable";
import SuccessPage from "./components/SuccessPage";
import Login from "./components/Login";
import AdultAccessories from "./components/AdultAccessories";
import KidsAccessories from "./components/KidsAccessories";
import KidProductDetail from "./components/KidProductDetail";
import SanmarImages from "./components/SanmarImages";
import ProductFTP from "./components/ProductFTP";
import SubscribersList from "./components/SubscribersList";
import TestShippo from "./components/TestShippo";
import AdminOrders from "./components/AdminOrders";
import OrdersPage from "./components/OrdersPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Protected from "./components/Protected";
import SignUp from "./components/SignUp";
import ScreenPrinting from "./components/ScreenPrinting";
import Embroidery from "./components/Embroidery";
import LaserEtching from "./components/LaserEtching";
import QuoteForm from "./components/Quote";
import ComingSoon from "./components/ComingSoon";
// import CommingSoon from "./components/CommingSoon";
import KidBlanks from "./components/KidBlanks";
import AdultsBlanks from "./components/AdultsBlanks";
import SpinningWheelGame from "./components/SpinningWheelGame";
import CustomStoreFromURL from "./components/pages/CustomStoreFromURL";
import ShippingGift from "./components/ShippingGift";
import WhiteProductList from "./components/WhiteProductList";
import WhiteProductDetail from "./components/WhiteProductDetail";
import AdminUsers from "./components/AdminUsers";
import KidsTable from "./components/KidsTable";
import AdultTable from "./components/AdultTable";
import BasicEmb from "./components/BasicEmb";
import ArtReq from "./components/ArtReq";
import EmbSpecial from "./components/EmbSpecial";
import EmbroideryStitches from "./components/EmbroideryStitches";
import Thread from "./components/Thread";
import TermsAndPolicy from "./components/TermsAndPolicy";
import ItemLookup from "./components/ItemLookup";
import DrinkwearMenu from "./components/DrinkwearMenu";
import DrinkwearDetail from "./components/DrinkwearDetail";
import AdultAccessoriesDetails from "./components/AdultAccessoriesDetails";
import CollectionUpdater from "./components/CollectionUpdater";
import TagsUpdater from "./components/TagsUpdater";
import FirestoreCsvExporter from "./components/FirestoreCsvExporter";
import FirestoreUpdater from "./components/FirestoreUpdater";
import SuccessGift from "./components/SuccessGift";
import SendArtDownloadEmail from "./components/SendArtDownloadEmail";
import CloudinaryUpload from "./components/CloudinaryUpload";
import CustomerReview from "./components/CustReview";
import MockUp from "./components/MockUp";
import StoreFront from "./components/pages/StoreFront";
import AdminDashboard from "./components/pages/AdminDashboard";
import CustomerReviewsDisplay from "./components/StarDisplay";
import SingleCollectionAdder from "./components/SingleCollectionAdder";
import BundleSelector from "./components/BundleSelector";
import MainStore from "./components/MainStore";
import ProductManager from "./components/ProductManager";
import ThemeController from "./components/ThemeController";
import Patches from "./components/Patches";
import Instruction from "./components/Instructions";
// import PlacePlanner from "./components/PlacePlanner";
import Nancy from "./components/Nancy";
import PlannerDb from "./components/PlannerDb";
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const libraries = ["places"]; // Required for Autocomplete

const App = () => {
  return (
    <CartProvider>
      <div
        className="app"
        style={{ paddingLeft: 15, paddingRight: 20, backgroundColor: "white" }}
      >
        <LoadScript
          googleMapsApiKey={GOOGLE_MAPS_API_KEY}
          libraries={libraries}
        >
          <BrowserRouter>
            <Nav />
            <Nav2 />
            <Routes>
              <Route index element={<MainStore />} />
              <Route path="about-us" element={<AboutUs />} />
              {/* <Route  path='/comingsoon' element={<CommingSoon />} /> */}
              <Route path="/kids-apparel-list" element={<ProductList />} />
              <Route path="/main-store" element={<MainStore />} />
               <Route path="/nancy" element={<Nancy />} />
              <Route
                path="/kids-apparel-list-white"
                element={<WhiteProductList />}
              />
              <Route path="/product/:style" element={<ProductDetail />} />
              <Route
                path="/white-product/:style"
                element={<WhiteProductDetail />}
              />
              <Route
                path="/kid-product/:style"
                element={<KidProductDetail />}
              />
              
              <Route
                path="/product-adult/:style"
                element={<ProductDetailAdult />}
              />
              <Route
                path="/product-drinkwear/:style"
                element={<DrinkwearDetail />}
              />
              <Route path="cancel" element={<Cancel />} />
              <Route path="success" element={<Success />} />
              <Route
                path="/mock"
                element={
                  // <Protected>
                  <MockUp />
                  // </Protected>
                }
              />
              <Route
                path="/theme"
                element={
                  <Protected>
                    <ThemeController />
                  </Protected>
                }
              />
              <Route path="stars" element={<CustomerReviewsDisplay />} />
              <Route path="customer-review" element={<CustomerReview />} />
              <Route
                path="/managersuccess"
                element={
                  <Protected>
                    <ProductPage />
                  </Protected>
                }
              />

              <Route path="bund" element={<BundleSelector />} />

              <Route path="/store/:storeCode" element={<StoreFront />} />

              <Route
                path="/admin-stores"
                element={
                  <Protected>
                    <AdminDashboard />{" "}
                  </Protected>
                }
              />
              <Route
                path="/myValues"
                element={
                  <Protected>
                    <PlannerDb />{" "}
                  </Protected>
                }
              />
              <Route path="/Contact-us" element={<ContactUs />} />
              <Route
                path="/product-manager"
                element={
                  // <Protected>
                  <ProductManager />
                  // </Protected>
                }
              />
              <Route path="/our-policy" element={<TermsAndPolicy />} />
              <Route path="/refund-policy" element={<Refund />} />
              <Route path="/terms" element={<Terms />} />
              {/* <Route path="/kidsBlanks" element={<KidsProductsBlankList />} /> */}
              <Route path="/kidsBlanks" element={<KidBlanks />} />
              <Route path="/adultsBlanks" element={<AdultsBlanks />} />
              <Route path="/our-subscribers" element={<SubscribersList />} />
              <Route path="/adult-apparel" element={<Adult />} />
              <Route
                path="/adult-accessories/:style"
                element={<AdultAccessoriesDetails />}
              />
              <Route path="/accessories-adult" element={<AdultAccessories />} />
              <Route
                path="/kids-accessories-list"
                element={<KidsAccessories />}
              />
                            <Route
                path="/how-to-care-for-custom-apparel"
                element={<Instruction />}
              />
              <Route path="/login" element={<Login />} />
              <Route path="/sanmarImages" element={<SanmarImages />} />
              <Route path="/gallery" element={<ImageTable />} />
              <Route path="/ftp" element={<ProductFTP />} />
              <Route
                path="/claim"
                element={
                  <ProtectedRoute>
                    <ShippingGift />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-field-updater"
                element={
                  <Protected>
                    <FirestoreUpdater />
                  </Protected>
                }
              />
              <Route path="/w&w-onlineStore" element={<CustomStoreFromURL />} />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-sales-updater"
                element={
                  //ino badan proteted khali kon k male admine
                  <Protected>
                    <CollectionUpdater />
                  </Protected>
                }
              />
              <Route
                path="/admin-csv-download"
                element={
                  //ino badan proteted khali kon k male admine
                  <Protected>
                    <FirestoreCsvExporter />
                  </Protected>
                }
              />
              <Route
                path="/admin-tags-updater"
                element={
                  //ino badan proteted khali kon k male admine
                  <ProtectedRoute>
                    <TagsUpdater />
                  </ProtectedRoute>
                }
              />

              <Route path="/imageSuccess" element={<SuccessPage />} />
              <Route path="/giftClaimSuccess" element={<SuccessGift />} />
              <Route path="/shippo" element={<TestShippo />} />
              <Route path="/game" element={<SpinningWheelGame />} />
               <Route path="/services/patches" element={<Patches />} />
              <Route
                path="/services/screen-printing"
                element={<ScreenPrinting />}
              />
              <Route path="/services/embroidery" element={<Embroidery />} />
              <Route path="/quote" element={<QuoteForm />} />
              <Route
                path="/services/laser-etching"
                element={<LaserEtching />}
              />
              <Route path="/kids-gallery" element={<KidsTable />} />
              <Route path="/adults-gallery" element={<AdultTable />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/art-requirements" element={<ArtReq />} />
              <Route path="/basic-embroidery" element={<BasicEmb />} />
              <Route path="/emb-specialties" element={<EmbSpecial />} />
              <Route path="/stitch-type" element={<EmbroideryStitches />} />
              <Route path="/thread-type" element={<Thread />} />
                 {/* <Route path="/vote" element={<PlacePlanner />} /> */}
              <Route
                path="/admin-all-items"
                element={
                  <Protected>
                    <ItemLookup />
                  </Protected>
                }
              />
              <Route path="/drinkwear-menu" element={<DrinkwearMenu />} />
              <Route
                path="/admin-orders"
                element={
                  <Protected>
                    <AdminOrders />
                  </Protected>
                }
              />
              <Route
                path="/admin-send-art-link"
                element={
                  <Protected>
                    <SendArtDownloadEmail />
                  </Protected>
                }
              />
              <Route
                path="/admin-add-collection-firebase"
                element={
                  <Protected>
                    <SingleCollectionAdder />
                  </Protected>
                }
              />
              <Route
                path="/admin-upload-file"
                element={
                  <Protected>
                    <CloudinaryUpload />
                  </Protected>
                }
              />
              <Route
                path="/admin-all-users"
                element={
                  <Protected>
                    <AdminUsers />
                  </Protected>
                }
              />
            </Routes>
            <Footer />
          </BrowserRouter>
        </LoadScript>
      </div>
    </CartProvider>
  );
};

export default App;
